import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap, take } from 'rxjs/operators';
import { NotificationService } from '~app/core/core.module';
import { ApplicationsService } from '~app/core/data/applications.service';
import { Application } from '~app/core/models/application.model';
import { TableCanDeactivate } from '~app/core/utils/can-deactivate/table-can-deactivate';
import { ApplicationService } from '../application.service';
import { VariableListComponent } from './variable-list/variable-list.component';

@Component({
  selector: 'idl-application-email-templates',
  templateUrl: './application-email-templates.component.html',
  styleUrls: ['./application-email-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ApplicationEmailTemplatesComponent extends TableCanDeactivate
  implements OnInit {
  application: Application;

  release_subject = '';
  release_email = '';
  release_subject_preview = '';
  release_preview = '';

  license_subject = '';
  license_email = '';
  license_subject_preview = '';
  license_preview = '';

  releaseVariables = {
    '{ApplicationName}': 'App Name',
    '{VersionGroup}': 'Group 1',
    '{FileID}': 1,
    '{FileName}': 'NewRelease.exe',
    '{FileVersion}': '1.0.0.0',
    '{ReleaseNotes}': 'Release Notes'
  };

  licenseVariables = {
    '{ApplicationName}': 'App Name',
    '{LicenseType}': 'Subscription',
    '{LicenseText}':
      '------BEGIN LICENSE ACTIVATION CODE------\nH4sIAAAAAAAAA5VUa1OjMBT9Kx396KRJILw6yIy2urLWqhXrut9SuDxcCJjQ1vLrl1IfuLMz',
    '{LicenseGUID}': '2a7580f0-c6dd-402e-ae97-b4344b9669e6'
  };

  emailForm = this._fb.group({
    release_subject: [''],
    release_email: [''],
    release_subject_preview: [''],
    license_subject: [''],
    license_email: [''],
    license_subject_preview: ['']
  });

  activeEdits = 0;

  constructor(
    private _applicationService: ApplicationService,
    private _applicationsService: ApplicationsService,
    private _bottomSheet: MatBottomSheet,
    private _fb: UntypedFormBuilder,
    private _notifications: NotificationService,
    private _route: ActivatedRoute
  ) {
    super();
    this.emailForm.get('release_subject').valueChanges.subscribe(val => {
      if (val) {
        this.emailForm.controls['release_subject_preview'].setValue(
          Object.keys(this.releaseVariables).reduce((prev, current) => {
            return prev.replace(
              new RegExp(current, 'gm'),
              this.releaseVariables[current]
            );
          }, val)
        );
        this.activeEdits = 1;
      }
    });

    this.emailForm.get('license_subject').valueChanges.subscribe(val => {
      if (val) {
        this.emailForm.controls['license_subject_preview'].setValue(
          Object.keys(this.licenseVariables).reduce((prev, current) => {
            return prev.replace(
              new RegExp(current, 'gm'),
              this.licenseVariables[current]
            );
          }, val)
        );
        this.activeEdits = 1;
      }
    });

    this.emailForm.get('release_email').valueChanges.subscribe(val => {
      if (val) {
        this.release_preview = Object.keys(this.releaseVariables).reduce(
          (prev, current) => {
            return prev.replace(
              new RegExp(current, 'gm'),
              this.releaseVariables[current]
            );
          },
          val
        );
        this.activeEdits = 1;
      }
    });

    this.emailForm.get('license_email').valueChanges.subscribe(val => {
      if (val) {
        this.license_preview = Object.keys(this.licenseVariables).reduce(
          (prev, current) => {
            return prev.replace(
              new RegExp(current, 'gm'),
              this.licenseVariables[current]
            );
          },
          val
        );
        this.activeEdits = 1;
      }
    });

    this._route.parent.paramMap
      .pipe(
        take(1),
        switchMap((params: ParamMap) =>
          this._applicationService.getApp(+params.get('id'))
        )
      )
      .subscribe(app => {
        if (app) {
          this.application = app;

          this.emailForm.patchValue({
            release_subject: this.application.versionUploadSubjectText,
            release_email: this.application.versionUploadBodyText,
            license_subject: this.application.licenseIssueSubjectText,
            license_email: this.application.licenseIssueBodyText
          });
          this.activeEdits = 0;
        }
      });
  }

  ngOnInit() {}

  viewVariables() {
    this._bottomSheet.open(VariableListComponent, {
      data: {
        releaseVariables: this.releaseVariables,
        licenseVariables: this.licenseVariables
      }
    });
  }

  submit() {
    this.application.versionUploadSubjectText = this.emailForm.value.release_subject;
    this.application.versionUploadBodyText = this.emailForm.value.release_email;
    this.application.licenseIssueSubjectText = this.emailForm.value.license_subject;
    this.application.licenseIssueBodyText = this.emailForm.value.license_email;

    this._applicationsService
      .edit(this.application)
      .pipe(take(1))
      .subscribe(app => {
        this._notifications.success('Application successfully saved.');
        this._applicationService.reloadApp();
        this.activeEdits = 0;
      });
  }
}
